export default __webpack_public_path__ + "static/media/Omb01.164268cb.png";